module.exports = __webpack_public_path__ + "img/icon2.7267cecc.png";